/**
 * Pay 页面公共配置
 * 所有品牌共享的文案和资源
 */

export const commonTexts = {
  tips: 'Tips:',
  tip1: '1. Coins are virtual items and cannot be refunded. They can only be used within this app.',
  tip2: '2. Reward coins are time-sensitive. Please use them within the 7-day validity period, as they will be deducted first when unlocking content. Coins are not redeemable or transferable to other users.',
  tip3: '3. For other questions, please contact us via Profile > Customer Service.',
} as const
